import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

// Pre-auth screens that render inside the shared auth shell — brand header,
// centred card, showcase panel, footer. Same chrome as sign-up, so the router
// nests these under the same layout component.
export const authShellRoutes: RouteRecordRaw[] = [
  {
    path: routes.LOGIN,
    name: 'LOGIN',
    component: () => import('./LoginPage.vue'),
    meta: { requiresGuest: true },
  },
  {
    path: routes.VERIFY_OTP,
    name: 'VERIFY_OTP',
    component: () => import('./VerifyOtpPage.vue'),
    meta: { requiresGuest: true },
  },
]

// Transient processing pages — no shell chrome, since the user only ever sees
// them mid-redirect.
export const authCallbackRoutes: RouteRecordRaw[] = [
  {
    // No guard: this is a transient processing page reached on return from UAE
    // Pass. It must run for BOTH guests (login / sign-up) and authenticated
    // users (enable UAE Pass from Account Settings). A `requiresGuest` here
    // would bounce a logged-in user to the dashboard before the callback can
    // exchange the code, silently breaking the enable-from-settings flow.
    path: routes.UAE_PASS_CALLBACK,
    name: 'UAE_PASS_CALLBACK',
    component: () => import('./UaePassCallbackPage.vue'),
  },
]

// Aggregate for any consumer that still needs the full set.
export const authRoutes: RouteRecordRaw[] = [...authShellRoutes, ...authCallbackRoutes]
